import Helpers from '@helpers';
import * as React from 'react';
import { initEvents } from './events';
import { initMenu } from './menu';
import { initSearch } from './search';
import { initSlider } from './slider';
import { lazyLoadImage } from './lazyLoadImage';
import { affiliateCookies } from './affiliateCookies';
import { skeletonPage } from './skeletonLoad';
import { initScrollToTop } from './scrollToTop';
import { validator } from './validator';
import { readMore } from './readMore';
import { bannerImage } from './bannerimage';
import { videoResize } from './videoResize';
import { installment } from './installment';
import videojs from 'video.js';

class MasterPageController extends React.Component {
    constructor(props) {
        super(props);
    }

    public componentDidMount() {
        initMenu();
        initSearch();
        initSlider();
        initEvents();
        lazyLoadImage();
        affiliateCookies();
        skeletonPage();
        initScrollToTop();
        validator();
        readMore();
        bannerImage();
        videoResize();
        installment();
    }

    public render() {
        return null;
    }
}

Helpers.ReactHelper.createReactElement('MasterPageController', MasterPageController);
